<div class="LI-profile-badge" data-version="v1" data-size="large" data-locale="en_US" data-type="vertical"
     [attr.data-theme]="getTheme()" data-vanity="jean-christophe-isoard-53671aa8">
</div>
